import { formatAbsolute, formatRelative } from "../lib/time.js";

/**
 * Renders a relative time ("5 minutes ago") with the absolute local timestamp
 * exposed on hover via `title`, so operators can recover the exact wall-clock
 * time needed to cross-reference a run against external logs.
 */
export function Timestamp({ iso }: { iso: string }) {
  return <span title={formatAbsolute(iso)}>{formatRelative(iso)}</span>;
}
